import Vue from 'vue'

const STORAGE_PREFIX = 'chemity.ui-preferences.v1:'

const isPresent = value => value !== null && typeof value !== 'undefined' && value !== ''

const createUiPreferenceScope = ({ subscriberId, organizationId }) => {
    if (!isPresent(subscriberId) || !isPresent(organizationId)) {
        return null
    }

    return `${String(subscriberId)}:${String(organizationId)}`
}

const isPlainObject = value => (
    value !== null
    && typeof value === 'object'
    && !Array.isArray(value)
)

const readStoredPreferences = () => {
    const preferencesByScope = {}

    for (let index = 0; index < localStorage.length; index += 1) {
        const storageKey = localStorage.key(index)

        if (!storageKey || !storageKey.startsWith(STORAGE_PREFIX)) {
            continue
        }

        const scopeKey = storageKey.slice(STORAGE_PREFIX.length)

        try {
            const preferences = JSON.parse(localStorage.getItem(storageKey))

            if (scopeKey && isPlainObject(preferences)) {
                preferencesByScope[scopeKey] = preferences
            }
        } catch (error) {
            // Invalid local UI preferences are ignored and replaced on the next update.
        }
    }

    return preferencesByScope
}

const persistScope = (scopeKey, preferences) => {
    localStorage.setItem(`${STORAGE_PREFIX}${scopeKey}`, JSON.stringify(preferences))
}

export default {
    namespaced: true,
    state: () => ({
        preferencesByScope: readStoredPreferences(),
    }),
    getters: {
        preference: state => ({ scopeKey, group, key, fallback = false }) => {
            if (!scopeKey) {
                return fallback
            }

            const scopePreferences = state.preferencesByScope[scopeKey]
            const groupPreferences = scopePreferences && scopePreferences[group]

            return groupPreferences && typeof groupPreferences[key] !== 'undefined'
                ? groupPreferences[key]
                : fallback
        },
    },
    mutations: {
        setPreference(state, {
            scopeKey,
            group,
            key,
            value,
        }) {
            if (!scopeKey || !group || !key) {
                return
            }

            const scopePreferences = state.preferencesByScope[scopeKey] || {}
            const groupPreferences = scopePreferences[group] || {}
            const nextPreferences = {
                ...scopePreferences,
                [group]: {
                    ...groupPreferences,
                    [key]: value,
                },
            }

            Vue.set(state.preferencesByScope, scopeKey, nextPreferences)
            persistScope(scopeKey, nextPreferences)
        },
    },
    actions: {
        setPreference({ commit }, preference) {
            commit('setPreference', preference)
        },
    },
}

export {
    STORAGE_PREFIX,
    createUiPreferenceScope,
    readStoredPreferences,
}
